import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { company } from '../config/company';
import s from '../styles/legalStyles';

const PrivacyPolicy = () => {
  return (
    <div style={s.page}>
      <SEO
        title="Polityka prywatności"
        description={`Polityka prywatności ${company.brand}. Dowiedz się, jak przetwarzamy dane osobowe zgodnie z RODO.`}
      />
      <div style={s.container}>
        <h1 style={s.title}>Polityka prywatności</h1>
        <p style={s.lastUpdated}>
          Ostatnia aktualizacja: {company.effectiveDate}
        </p>

        <article style={s.article}>
          <p>
            {company.brand} (działający jako {company.name}, dalej „my”, „nas” lub „{company.brand}”)
            przywiązuje dużą wagę do ochrony Twoich danych osobowych. W niniejszej polityce prywatności
            wyjaśniamy, jak postępujemy z danymi osobowymi zbieranymi za pośrednictwem naszej strony {company.website}.
          </p>

          <h2 style={s.h2}>1. Administrator danych</h2>
          <p>
            {company.name}<br />
            {company.street}<br />
            {company.postalCity}<br />
            {company.country}<br />
            KvK: {company.kvk}<br />
            E-mail: <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>
          </p>

          <h2 style={s.h2}>2. Jakie dane osobowe zbieramy?</h2>
          <p>Zbieramy wyłącznie dane niezbędne do działania naszej strony i świadczenia usług:</p>
          <ul style={s.list}>
            <li><strong>Dane kontaktowe:</strong> gdy kontaktujesz się z nami przez WhatsApp lub e-mail (imię, telefon, adres e-mail).</li>
            <li><strong>Zapisy do newslettera i przewodników:</strong> gdy pobierasz bezpłatny przewodnik lub zapisujesz się na nasze wiadomości marketingowe, przetwarzamy Twoje imię i adres e-mail. Okresowo wysyłamy <strong>najnowsze oferty nieruchomości</strong>, praktyczne porady o kupowaniu w Hiszpanii oraz aktualności CasaOthers. Możesz wypisać się jednym kliknięciem na dole każdej wiadomości.</li>
            <li><strong>Zachowanie na stronie:</strong> przez Google Analytics 4 zbieramy zanonimizowane statystyki odwiedzin.</li>
            <li><strong>Dane techniczne:</strong> adres IP, typ przeglądarki, typ urządzenia, preferencje językowe.</li>
            <li><strong>Śledzenie kliknięć:</strong> gdy klikniesz „Zobacz nieruchomość”, anonimowo rejestrujemy, która nieruchomość została kliknięta.</li>
          </ul>

          <h2 style={s.h2}>3. Cele i podstawy prawne</h2>
          <p>Przetwarzamy Twoje dane w następujących celach:</p>
          <ul style={s.list}>
            <li><strong>Świadczenie usług:</strong> przekierowanie Cię do naszego partnera Nelemans (uzasadniony interes).</li>
            <li><strong>Optymalizacja strony:</strong> zrozumienie, które nieruchomości i strony są popularne (zgoda przez pliki cookie).</li>
            <li><strong>Komunikacja:</strong> odpowiadanie na Twoje pytania przez WhatsApp lub e-mail (wykonanie umowy / zgoda).</li>
            <li><strong>Bezpłatne przewodniki i newsletter:</strong> dostarczenie pobranego przewodnika oraz — jeśli wyraziłeś na to wyraźną zgodę — okresowe wysyłanie najnowszych ofert i porad (podstawa: zgoda — możesz ją wycofać w każdej chwili).</li>
            <li><strong>Obowiązki prawne:</strong> obowiązki przechowywania danych wynikające z prawa holenderskiego i unijnego.</li>
          </ul>

          <h2 style={s.h2}>4. Przekazywanie stronom trzecim</h2>
          <p>Udostępniamy Twoje dane wyłącznie:</p>
          <ul style={s.list}>
            <li><strong>Nelemans</strong>: naszemu partnerowi nieruchomości w Hiszpanii (tylko jeśli sam przejdziesz do ich strony).</li>
            <li><strong>Resend</strong>: dostawcy usług e-mail (hosting w UE) — do wysyłania przewodników i newslettera.</li>
            <li><strong>Google LLC</strong>: dla Google Analytics 4 i Google Tag Manager (lokalizacja serwerów w UE).</li>
            <li><strong>Meta (WhatsApp)</strong>: gdy kontaktujesz się przez WhatsApp.</li>
            <li><strong>Dostawca hostingu</strong>: do hostowania tej strony.</li>
          </ul>
          <p>Nigdy nie sprzedajemy ani nie wynajmujemy Twoich danych stronom trzecim w celach komercyjnych.</p>

          <h2 style={s.h2}>5. Okres przechowywania</h2>
          <p>Nie przechowujemy danych osobowych dłużej niż to konieczne:</p>
          <ul style={s.list}>
            <li>Zapytania kontaktowe: maksymalnie 2 lata od ostatniego kontaktu.</li>
            <li>Zapisy do newslettera: do momentu wypisania. Natychmiast potem Twój adres jest usuwany z listy mailingowej.</li>
            <li>Pobierający przewodniki (bez zapisu do newslettera): maksymalnie 12 miesięcy.</li>
            <li>Dane analityczne: maksymalnie 14 miesięcy w Google Analytics.</li>
            <li>Śledzenie kliknięć: maksymalnie 12 miesięcy, potem anonimizowane.</li>
          </ul>

          <h2 style={s.h2}>6. Twoje prawa (RODO)</h2>
          <p>Masz prawo do:</p>
          <ul style={s.list}>
            <li>Dostępu do swoich danych.</li>
            <li>Sprostowania lub usunięcia swoich danych.</li>
            <li>Sprzeciwu wobec przetwarzania.</li>
            <li>Wycofania zgody na pliki cookie.</li>
            <li>Złożenia skargi do <a style={s.link} href="https://uodo.gov.pl" target="_blank" rel="noopener noreferrer">Urzędu Ochrony Danych Osobowych</a>.</li>
          </ul>
          <p>
            Wyślij swoje żądanie na{' '}
            <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>. Odpowiadamy w ciągu 30 dni.
          </p>

          <h2 style={s.h2}>7. Bezpieczeństwo</h2>
          <p>
            Stosujemy odpowiednie środki techniczne i organizacyjne w celu zabezpieczenia Twoich danych, w tym
            szyfrowanie HTTPS, bezpieczne hasła (bcrypt) i ograniczony dostęp do danych.
          </p>

          <h2 style={s.h2}>8. Zmiany</h2>
          <p>
            Możemy w każdej chwili zaktualizować niniejszą politykę prywatności. Najbardziej aktualna wersja
            znajduje się zawsze na tej stronie, z datą na górze.
          </p>

          <h2 style={s.h2}>9. Kontakt</h2>
          <p>
            Pytania dotyczące prywatności? Napisz do nas na{' '}
            <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a> lub wyślij{' '}
            <a style={s.link} href={company.whatsappUrl} target="_blank" rel="noopener noreferrer">wiadomość WhatsApp</a>.
          </p>

          <p style={s.footnote}>
            Zobacz także naszą <Link style={s.link} to="/cookies">Politykę plików cookie</Link> oraz{' '}
            <Link style={s.link} to="/voorwaarden">Regulamin</Link>.
          </p>
        </article>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
